export const notificationsEndpoints = {
  getScheduledNotifications: {
    path: '/admin/AdminNotification/GetScheduledNotifications',
    method: 'GET' as const,
  },
  sendToCustomer: {
    path: '/admin/AdminNotification/SendToCustomer',
    method: 'POST' as const,
  },
  sendToMultipleCustomers: {
    path: '/admin/AdminNotification/SendToMultipleCustomers',
    method: 'POST' as const,
  },
  sendToTopic: {
    path: '/admin/AdminNotification/SendToTopic',
    method: 'POST' as const,
  },
  sendBroadcast: {
    path: '/admin/AdminNotification/SendBroadcast',
    method: 'POST' as const,
  },
  scheduleNotification: {
    path: '/admin/AdminNotification/ScheduleNotification',
    method: 'POST' as const,
  },
  updateScheduledNotification: (id: number) => ({
    path: `/admin/AdminNotification/UpdateScheduledNotification/${id}`,
    method: 'PUT' as const,
  }),
  cancelScheduledNotification: (id: number) => ({
    path: `/admin/AdminNotification/CancelScheduledNotification/${id}`,
    method: 'DELETE' as const,
  }),
  deleteScheduledNotification: (id: number) => ({
    path: `/admin/AdminNotification/DeleteScheduledNotification/${id}/delete`,
    method: 'DELETE' as const,
  }),
  getNotificationAnalytics: {
    path: '/admin/AdminNotification/GetNotificationAnalytics',
    method: 'GET' as const,
  },
  getNotificationHistory: {
    path: '/admin/AdminNotification/GetNotificationHistory',
    method: 'GET' as const,
  },
  // Query Builder Endpoints
  getQueryBuilderMetadata: {
    path: '/admin/AdminNotification/GetQueryBuilderMetadata',
    method: 'GET' as const,
  },
  getTableColumns: (tableName: string) => ({
    path: `/admin/AdminNotification/GetTableColumns/${tableName}`,
    method: 'GET' as const,
  }),
  previewCustomerQuery: {
    path: '/admin/AdminNotification/PreviewCustomerQuery',
    method: 'POST' as const,
  },
  getQueryFromCriteria: {
    path: '/admin/AdminNotification/GetQueryFromCriteria',
    method: 'POST' as const,
  },
  getScheduledNotificationById: (id: number) => ({
    path: `/admin/AdminNotification/GetScheduledNotificationById/${id}`,
    method: 'GET' as const,
  }),
} as const;
